/**
 * Contagem de tempo escrita para quem lê: "1 dia", "3 dias", "1 mês".
 *
 * A unidade concorda com o número. Parece óbvio, e mesmo assim o plural fixo
 * ("há ${dias} dias") passou por quatro telas: o aviso de contrato que saiu do
 * SOMA dizia "há 1 dias" justamente no primeiro dia, que é quando ele mais
 * importa (tarefa wdwxndyrut). Um aviso que pede para ser levado a sério perde
 * crédito com erro de concordância.
 *
 * Quem escreve contagem de tempo em texto de tela usa estas funções em vez de
 * montar a frase à mão. O teste `tests/lib/contagem-de-dias.test.ts` varre
 * `src/` e reprova o plural fixo novo.
 */

function contagem(n: number, singular: string, plural: string): string {
  return `${n} ${n === 1 ? singular : plural}`
}

/** "1 dia", "0 dias", "12 dias". */
export function emDias(n: number): string {
  return contagem(n, "dia", "dias")
}

/** "1 mês", "4 meses". */
export function emMeses(n: number): string {
  return contagem(n, "mês", "meses")
}

/** "1 ano", "2 anos". */
export function emAnos(n: number): string {
  return contagem(n, "ano", "anos")
}
